import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AuthShell, Field, Divider, GoogleIcon } from "@/pages/LoginPage";

// REMINDER: DO NOT HARDCODE THE URL OR ADD ANY FALLBACKS — THIS BREAKS THE AUTH.
function startGoogleAuth() {
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href =
        "https://auth.emergentagent.com/?redirect=" +
        encodeURIComponent(redirectUrl);
}

export default function SignupPage() {
    const { signup } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [name, setName] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    async function onSubmit(e) {
        e.preventDefault();
        setError("");
        if (password.length < 6) {
            setError("Password must be at least 6 characters.");
            return;
        }
        setLoading(true);
        try {
            await signup(email.trim(), password, name.trim() || undefined);
            navigate("/", { replace: true });
        } catch (err) {
            const detail = err?.response?.data?.detail || "Signup failed";
            setError(detail);
        } finally {
            setLoading(false);
        }
    }

    return (
        <AuthShell
            title="Create your account"
            subtitle="Save your trips and resume conversations"
        >
            <form
                onSubmit={onSubmit}
                className="flex flex-col gap-3"
                data-testid="signup-form"
            >
                <Field
                    label="Name (optional)"
                    type="text"
                    value={name}
                    onChange={setName}
                    testId="signup-name"
                />
                <Field
                    label="Email"
                    type="email"
                    value={email}
                    onChange={setEmail}
                    testId="signup-email"
                />
                <Field
                    label="Password"
                    type="password"
                    value={password}
                    onChange={setPassword}
                    testId="signup-password"
                />
                {error && (
                    <p
                        className="text-[12px] text-[#DC2626]"
                        data-testid="signup-error"
                    >
                        {error}
                    </p>
                )}
                <button
                    type="submit"
                    disabled={loading || !email || !password}
                    data-testid="signup-submit"
                    className="mt-2 inline-flex h-10 items-center justify-center rounded-lg bg-[#0A0A0A] text-[14px] font-medium text-white transition hover:bg-[#262626] disabled:bg-[#E5E5E5] disabled:text-[#A3A3A3]"
                >
                    {loading ? "Creating…" : "Create account"}
                </button>
            </form>

            <Divider />

            <button
                type="button"
                onClick={startGoogleAuth}
                data-testid="signup-google"
                className="inline-flex h-10 items-center justify-center gap-2 rounded-lg border border-[#E5E5E5] bg-white text-[14px] font-medium text-[#0A0A0A] transition hover:border-[#0A0A0A] hover:bg-[#F5F5F5]"
            >
                <GoogleIcon />
                Continue with Google
            </button>

            <p className="mt-6 text-center text-[13px] text-[#737373]">
                Already have an account?{" "}
                <Link
                    to="/login"
                    className="font-medium text-[#0A0A0A] underline underline-offset-2"
                    data-testid="link-to-login"
                >
                    Sign in
                </Link>
            </p>
        </AuthShell>
    );
}
